import React, { useEffect } from 'react';
import { useNotifications } from '@/contexts/NotificationContext';
import { notificationService } from '@/lib/api/notification-service';
import { useDesign } from '@/contexts/DesignContext';
import { useAuth } from '@/contexts/AuthContext';
import { cn } from '@/lib/utils';
import { Toaster } from '@/components/ui/toaster';

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { config } = useDesign();
  const { isAuthenticated } = useAuth();
  const [toastSettings, setToastSettings] = React.useState({
    duration: 5000,
    position: 'top-right',
    maxVisible: 3
  });

  // Load toast settings from backend only if authenticated
  useEffect(() => {
    if (!isAuthenticated) return;
    
    const loadSettings = async () => {
      try {
        const settings = await notificationService.getToastSettings();
        setToastSettings({
          duration: settings.toast_duration_ms || 5000,
          position: (settings.toast_position || 'top-right') as ToastPosition,
          maxVisible: settings.toast_max_visible || 3
        });
      } catch (error) {
        console.error('Failed to load toast settings:', error);
      }
    };
    
    void loadSettings();
  }, [isAuthenticated]);

  return (
    <>
      {children}
      {/* Non-error toasts: Admin-defined position */}
      <Toaster position={toastSettings.position as any} filterVariant="non-destructive" />
      {/* Error toasts: always bottom-right */}
      <Toaster position="bottom-right" filterVariant="destructive" />
    </>
  );
};